import {
  FormControl,
  FormControlProps,
  Input,
  InputAdornment,
  InputLabel,
} from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { ChangeEventHandler, FC } from "react";

interface Props extends FormControlProps {
  label: string;
  placeholder?: string;
  variant?: "standard" | "outlined" | "filled";
  onChange: ChangeEventHandler<HTMLInputElement>;
}

const SearchInput: FC<Props> = ({
  label,
  variant = "standard",
  placeholder,
  onChange,
  ...restProps
}) => {
  return (
    <FormControl variant={variant} sx={{ minWidth: 240 }} {...restProps}>
      <InputLabel>{label}</InputLabel>
      <Input
        startAdornment={
          <InputAdornment position="start">
            <SearchOutlinedIcon />
          </InputAdornment>
        }
        placeholder={placeholder}
        onChange={onChange}
      />
    </FormControl>
  );
};

export default SearchInput;
